export default __webpack_public_path__ + "static/media/regreen_visual_07.535d57da.jpg";